import React from "react";
import PortfolioGrid from "./PortfolioGrid";
import './css/PortfolioPage.css';

const PortfolioPage = () => {
    return (
        <div className="portfolio-container">
            {/*<div className="empty-space"></div>*/}
            <div className="pf-page-grid-container">
                <PortfolioGrid />
            </div>
        </div>
    );
};

export default PortfolioPage;
